import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  apply(event) {
    const select = event.currentTarget
    const value = select.value

    if (!value) {
      Turbo.visit(select.dataset.defaultUrl)
      return
    }

    const [sortBy, sortDirection] = value.split("_")
    const url = new URL(select.dataset.baseUrl, window.location.origin)
    const params = JSON.parse(select.dataset.params || "{}")

    Object.entries(params).forEach(([key, val]) => {
      if (val) url.searchParams.set(key, val)
    })

    url.searchParams.set("sort_by", sortBy)
    url.searchParams.set("sort_direction", sortDirection)

    Turbo.visit(url.toString())
  }
}
